import { GraphQLFleetContractsRequester } from '@cobliteam/api-lib';
import type { FleetCompanyContract, FleetCompanyOnboardingStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

const FLEET_CONTRACT_KEY = 'FLEET_CONTRACT';
const graphQLRequester = () => new GraphQLFleetContractsRequester();

const useFleetContracts = (fleetId: string, options: Partial<UseQueryOptions<FleetCompanyContract[]>> = {}) => {
  return useQuery<FleetCompanyContract[]>({
    queryKey: [FLEET_CONTRACT_KEY],
    queryFn: () => graphQLRequester().getFleetContracts(fleetId),
    retry: false,
    refetchOnMount: false,
    ...options,
  });
};

const useFleetCompanyOnboardingStatus = (fleetId: string) => {
  return useQuery<FleetCompanyOnboardingStatus>({
    queryKey: [FLEET_CONTRACT_KEY, 'onboardingStatus'],
    queryFn: () => graphQLRequester().getFleetCompanyOnboardingStatus(fleetId),
  });
};

export { useFleetCompanyOnboardingStatus, useFleetContracts };
